// extracted by mini-css-extract-plugin
var _1 = "TaskTypeListMoreButton-modulebutton__gcweT";
export { _1 as "button" }
